
            var preact = window.preact;
            module.exports = {
              jsx: preact.h,
              jsxs: preact.h,
              jsxDEV: preact.h,
              Fragment: preact.Fragment,
            };
          